import { connect } from 'react-redux';
import { deviationThreadUpdated } from '../../../CommentThread/actionCreators';
import { focusEditor } from '../../../CommentEditor/redux/actionCreators';
var mapDispatchToProps = {
    onThreadUpdated: deviationThreadUpdated,
    focusEditor: focusEditor,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=CommentBoxPanel.container.js.map